import React from "react";
import { Table, Icon, Button } from "semantic-ui-react";
import { Tooltip } from "react-tooltip";
import { useAuth } from "../../../../hook/userAuth";

export function TableCalificacionesCurso(props) {
  const {
    alumnosCali,
    numero_unidades,
    bajaCursoAlumno,
    regularizacion,
    asignarCalificacion,
    alumno_id,
    es_materia_titulacion,
  } = props;
  const unidadesArray = Array.from(
    { length: numero_unidades },
    (_, index) => index + 1
  );

  // Ordenar los alumnos por apellido paterno, y luego por apellido materno
  const alumnosOrdenados = [...alumnosCali].sort((a, b) => {
    const apellidoPaternoA = a.alumno_data.apellido_paterno.toLowerCase();
    const apellidoPaternoB = b.alumno_data.apellido_paterno.toLowerCase();
    const apellidoMaternoA = a.alumno_data.apellido_materno.toLowerCase();
    const apellidoMaternoB = b.alumno_data.apellido_materno.toLowerCase();

    if (apellidoPaternoA < apellidoPaternoB) return -1;
    if (apellidoPaternoA > apellidoPaternoB) return 1;
    if (apellidoMaternoA < apellidoMaternoB) return -1;
    if (apellidoMaternoA > apellidoMaternoB) return 1;
    return 0;
  });

  return (
    <div>
      <Table className="table-users-admin">
        <Table.Header>
          <Table.Row>
            {es_materia_titulacion &&
            es_materia_titulacion.materia_data.es_de_titulacion ? (
              <Table.HeaderCell>ASESOR ASIGNADO</Table.HeaderCell>
            ) : (
              <Table.HeaderCell>NUM. DE LISTA</Table.HeaderCell>
            )}
            <Table.HeaderCell>NOMBRE ALUMNO</Table.HeaderCell>
            {unidadesArray.map((numero) => (
              <Table.HeaderCell key={numero}>U {numero}</Table.HeaderCell>
            ))}
            <Table.HeaderCell>E. FINAL</Table.HeaderCell>
            <Table.HeaderCell>% ASISTENCIA</Table.HeaderCell>
            <Table.HeaderCell>CALIF. R1</Table.HeaderCell>
            <Table.HeaderCell>FECHA R1</Table.HeaderCell>
            <Table.HeaderCell>CALIF. R2</Table.HeaderCell>
            <Table.HeaderCell>FECHA R2</Table.HeaderCell>
            <Table.HeaderCell>ACCIÓN</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {alumnosOrdenados.map((alumno, index) => (
            <Table.Row
              key={index}
              style={
                alumno_id && alumno.alumno_data.id === alumno_id
                  ? { backgroundColor: "#b3cde0" }
                  : {}
              }
            >
              {es_materia_titulacion &&
              es_materia_titulacion.materia_data.es_de_titulacion ? (
                <Table.Cell>
                  {alumno.docente_asesor_data
                    ? `${alumno.docente_asesor_data.first_name} ${alumno.docente_asesor_data.last_name}`
                    : "SIN ASESOR ASIGNADO"}
                </Table.Cell>
              ) : (
                <Table.Cell>{index + 1}</Table.Cell>
              )}

              <Table.Cell>
                {`${alumno.alumno_data.apellido_paterno} ${alumno.alumno_data.apellido_materno} ${alumno.alumno_data.nombre}`}
                {alumno.alumno_data.alumno_traslado && (
                  <span style={{ color: "red", fontSize: "0.8em" }}>
                    {" "}
                    (traslado)
                  </span>
                )}
              </Table.Cell>

              {unidadesArray.map((numero) => (
                <Table.Cell key={numero}>
                  {alumno[`calificacion_parcial_${numero}`] !== null
                    ? alumno[`calificacion_parcial_${numero}`]
                    : ""}
                </Table.Cell>
              ))}
              <Table.Cell>{alumno.calificacion_final}</Table.Cell>
              <Table.Cell>{alumno.porcentaje_asistencia}</Table.Cell>
              <Table.Cell>{alumno.regularizacion_1}</Table.Cell>
              <Table.Cell>{alumno.fecha_regularizacion_1}</Table.Cell>
              <Table.Cell>{alumno.regularizacion_2}</Table.Cell>
              <Table.Cell>{alumno.fecha_regularizacion_2}</Table.Cell>

              <Actions
                alumnosCali={alumno}
                bajaCursoAlumno={bajaCursoAlumno}
                regularizacion={regularizacion}
                asignarCalificacion={asignarCalificacion}
              />
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button.Group></Button.Group>
      </div>
    </div>
  );
}

function Actions(props) {
  const { alumnosCali, bajaCursoAlumno, regularizacion, asignarCalificacion } =
    props;
  const { auth } = useAuth();
  return (
    <Table.Cell textAlign="center">
      <div className="action-buttons">
        <Button
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Dar de baja del curso"
          icon
          negative
          onClick={() => {
            bajaCursoAlumno(alumnosCali);
          }}
        >
          <Icon name="minus circle" style={{ color: "white" }} />
        </Button>
        <Button
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Asignar calificaciones de regularización"
          icon
          onClick={() => {
            regularizacion(alumnosCali);
          }}
          className="botonEnviar"
        >
          <Icon name="pencil" style={{ color: "white" }} />
        </Button>
        {auth.me.permiso_cargar_calificaciones && (
          <Button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Registrar calificaciones"
            icon
            onClick={() => {
              asignarCalificacion(alumnosCali);
            }}
            className="yellow"
          >
            <Icon name="file alternate outline" style={{ color: "white" }} />
          </Button>
        )}
        <Tooltip id="my-tooltip" />
      </div>
    </Table.Cell>
  );
}
